// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  // Link,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import { PinInput } from "react-input-pin-code";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

// import { useMaterialUIController } from "context";

function CreatePayout() {
  const pageTitle = "Bank Transfer";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openConfirmDialog, setConfirmDialog] = useState(false);
  const [openStatusDialog, setStatusDialog] = useState(false);
  const [statusMessage, setStatusMessage] = useState(
    "Your transfer has been submitted successfully. This may take a few moments to process."
  );
  const [pinValues, setPinValues] = useState(["", "", "", ""]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState(null);
  // const [incomeSources, setIncomeSources] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [currencyBeneficiaries, setCurrencyBeneficiaries] = useState([]);
  const [transferAmountText, setTransferAmountText] = useState("Amount");
  const [beneficiaryType, setBeneficiaryType] = useState(null);
  const [paymentParameters, setPaymentParameters] = useState([]);
  const [currencyPaymentParameters, setCurrencyPaymentParameters] = useState([]);
  const [userPaymentInfo, setUserPaymentInfo] = useState({});
  const [beneficiarySwitch, setBeneficiarySwitch] = useState(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [userPin, setUserPin] = useState(null);
  const [beneficiaryName, setBeneficiaryName] = useState(null);
  const [feeObjects, setFeeObjects] = useState(null);
  const [transferFee, setTransferFee] = useState(null);
  const [totalSpendAmount, setTotalSpendAmount] = useState(null);
  const [state, setState] = useState({});
  const {
    // incomeSource = null,
    transferAmount = 0,
    transferNarration = null,
    // pin = null,
    // beneficiary = null,
  } = state;

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/payouts/create/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrencies(result.data.data.result.currencies);
            // setIncomeSources(result.data.data.result.income_sources);
            setBeneficiaries(result.data.data.result.beneficiaries);
            setPaymentParameters(result.data.data.result.payment_parameters);
            setFeeObjects(result.data.data.result.fee_objects);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("transfer-bank")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function calculateFee(amount, feeObject) {
    let tFee = feeObject.fee;
    if (feeObject.is_percentage) {
      tFee = amount * feeObject.fee;
      if (feeObject.minimum > 0) {
        tFee = feeObject.minimum > tFee ? feeObject.minimum : tFee;
      }

      if (feeObject.maximum > 0) {
        tFee = feeObject.maximum < tFee ? feeObject.maximum : tFee;
      }

      tFee += feeObject.mandatory_fee;
    }

    let cDiscount = feeObject.discount;
    if (feeObject.is_discount_percentage) {
      cDiscount = tFee * feeObject.discount;
    }

    tFee -= cDiscount;
    return tFee / 100;
  }

  useEffect(() => {
    const curText = currency === null ? "Amount" : `${currency} Amount`;
    setTransferAmountText(curText);
  }, [currency]);

  useEffect(() => {
    setCurrencyPaymentParameters([]);
    setBeneficiaryType(null);
    setSelectedBeneficiary(null);
    setBeneficiaryName(null);
    setUserPaymentInfo({});
  }, [beneficiarySwitch]);

  useEffect(() => {
    if (currency === null || beneficiaryType === null) {
      return;
    }

    if (beneficiarySwitch === "saved") {
      return;
    }

    setBeneficiaryName(null);
    setCurrencyPaymentParameters(paymentParameters[currency][beneficiaryType]);
  }, [currency, beneficiaryType]);

  useEffect(() => {
    if (currency === null || transferAmount === null || transferAmount <= 0) {
      return;
    }
    const fee = calculateFee(transferAmount, feeObjects[currency]);
    setTransferFee(fee);
    setTotalSpendAmount(parseFloat(transferAmount) + fee);
  }, [currency, transferAmount]);

  const getBeneficiaryName = async (query) => {
    setBeneficiaryName("");
    setShowLoading(true);
    const params = {
      type: "bank_transfer",
      search: {
        destination: query,
      },
    };
    await axios
      .post("users/payouts/name/search.json", params)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setBeneficiaryName(response.data.data.name);
        } else {
          setBeneficiaryName(null);
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("Unable to resolve beneficiary account name.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleUserInfoChange = () => {
    setBeneficiaryName(null);
    if (currency === "NGN") {
      if (userPaymentInfo.account_number && userPaymentInfo.bank_code) {
        const query = {
          currency: "NGN",
          account_number: userPaymentInfo.account_number,
          bank_code: userPaymentInfo.bank_code,
        };
        getBeneficiaryName(query);
      }
    }
  };

  useEffect(() => {
    if (currency === "NGN") {
      let theBen = null;
      currencyBeneficiaries.every((param) => {
        if (param.reference === selectedBeneficiary) {
          theBen = param;
          return false;
        }
        return true;
      });

      if (theBen !== null) {
        const query = {
          currency: "NGN",
          account_number: theBen.banking_details.account_number,
          bank_code: theBen.banking_details.bank_code,
        };
        getBeneficiaryName(query);
      }
    }
  }, [selectedBeneficiary]);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleCurrencyChange = (currencyCode) => {
    setCurrency(currencyCode);
    setCurrencyBeneficiaries(beneficiaries[currencyCode]);
  };

  const handleuserPaymentInfoChange = (event) => {
    setBeneficiaryName(null);
    const arr = userPaymentInfo;
    arr[event.target.name] = event.target.value;
    setUserPaymentInfo(arr);
  };

  const postData = async (params) => {
    setShowLoading(true);
    await axios
      .post("users/payouts/create.json", params)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          const msg =
            "Transfer request received. This may take a few moments to process successfully.";
          setErrMsg(msg);
          setOpen(true);

          setStatusMessage(msg);
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again in a few moments.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (currency === null) {
      setSeverity("error");
      setErrMsg("Transfer currency is required");
      setOpen(true);
      return;
    }

    // if (incomeSource === null) {
    //   setSeverity("error");
    //   setErrMsg("Please indicate an income source for funds to be transfered.");
    //   setOpen(true);
    //   return;
    // }

    if (transferAmount === null || transferAmount === 0) {
      setSeverity("error");
      setErrMsg("Please enter an amount to transfer.");
      setOpen(true);
      return;
    }

    if (transferNarration === null || transferNarration === "") {
      setSeverity("error");
      setErrMsg("A narration of transfer is required");
      setOpen(true);
      return;
    }

    if (beneficiarySwitch === "---" || beneficiarySwitch === null) {
      setSeverity("error");
      setErrMsg("Please select an option.");
      setOpen(true);
      return;
    }

    if (beneficiarySwitch === "saved") {
      if (selectedBeneficiary === null) {
        setSeverity("error");
        setErrMsg("Please select a beneficiary.");
        setOpen(true);
        return;
      }
    }

    if (beneficiarySwitch === "new") {
      if (beneficiaryType === null) {
        setSeverity("error");
        setErrMsg("Please select a beneficiary type.");
        setOpen(true);
        return;
      }

      let error = false;
      currencyPaymentParameters.every((param) => {
        if (!userPaymentInfo[param.param] || userPaymentInfo[param.param].length < 1) {
          error = `${param.display_name} is required.`;
          return false;
        }
        return true;
      });

      if (error) {
        setSeverity("error");
        setErrMsg(error);
        setOpen(true);
        return;
      }

      if (beneficiaryName === null) {
        setSeverity("error");
        setErrMsg("Beneficiary account holder name unresolved");
        setOpen(true);
        return;
      }
    }

    setPinValues(["", "", "", ""]);
    setShowConfirmDialog(true);
  };

  function confirmSubmit() {
    const params = {
      currency: `${currency}`,
      // income_source: incomeSource,
      transfer_type: "bank_transfer",
      amount: transferAmount * 100,
      narration: transferNarration,
      beneficiary_name: beneficiaryName,
      pin: userPin,
    };

    if (beneficiarySwitch === "new") {
      params.beneficiary = userPaymentInfo;
      params.beneficiary_type = beneficiaryType;
    } else {
      currencyBeneficiaries.every((param) => {
        if (param.reference === selectedBeneficiary) {
          params.beneficiary = param.banking_details;
          return false;
        }
        return true;
      });
    }
    // console.log(params);
    postData(params);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <Dialog open={showConfirmDialog}>
        <DialogTitle>Authorize Transaction</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="h6" fontWeight="light">
              Enter your pin to authorize transaction.
            </MDTypography>
            <MDBox mt={2}>
              <PinInput
                values={pinValues}
                onChange={(value, index, values) => setPinValues(values)}
                length={4}
                mask
                autoTab
                placeholder="-"
                onComplete={(text) => {
                  let up = "";
                  text.forEach((itm) => {
                    up += itm;
                  });
                  setUserPin(up);
                }}
              />
            </MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setShowConfirmDialog(false);
            }}
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              if (userPin !== null && userPin.length === 4) {
                setShowConfirmDialog(false);
                setConfirmDialog(true);
              }
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirmDialog}>
        <DialogTitle>Confirm Transfer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="text" color="dark">
              Are you sure you want to proceed with this transfer?
            </MDTypography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setConfirmDialog(false);
            }}
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setConfirmDialog(false);
              confirmSubmit();
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openStatusDialog}>
        <DialogTitle>Funds Sent</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="text" color="dark">
              {statusMessage}
            </MDTypography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setStatusDialog(false);
              navigate("/transfers");
            }}
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox sx={{ marginBottom: "40px" }}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                      <MDButton
                        variant="link"
                        color={darkMode ? "white" : "dark"}
                        onClick={() => {
                          navigate("/payouts");
                        }}
                      >
                        My Transfers
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid> */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Bank Transfer
                      </MDTypography>
                      <MDBox mt={1}>
                        <MDTypography variant="h6" fontWeight="light">
                          Transfer money instantly and securely to any bank account.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5}>
                        <MDBox mb={1}>
                          <Grid container spacing={3}>
                            <Grid item xs={5} md={5} lg={4}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  onChange={(e) => {
                                    setCurrency(e.target.value);
                                    handleCurrencyChange(e.target.value);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      currencies.map((record) => {
                                        if (record.payout_enabled) {
                                          return (
                                            <MenuItem value={record.currency_code}>
                                              {record.currency_code}
                                            </MenuItem>
                                          );
                                        }
                                        return null;
                                      })
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={7} md={7} lg={8}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <MDInput
                                  type="number"
                                  name="transferAmount"
                                  label={transferAmountText}
                                  sx={{ minWidth: 120, width: "100%" }}
                                  onChange={handleChange}
                                />
                              </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Income Source</InputLabel>
                                <Select
                                  name="incomeSource"
                                  onChange={handleChange}
                                  label="Income Source"
                                  // onChange={(e) => handleCurrencyChange(e.target.value)}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    incomeSources.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      incomeSources.map((record) => (
                                        <MenuItem value={record.code}>{record.title}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid> */}
                          </Grid>
                          {/* <MDBox mt={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                type="number"
                                name="transferAmount"
                                label={transferAmountText}
                                sx={{ minWidth: 120, width: "100%" }}
                                onChange={handleChange}
                              />
                            </FormControl>
                          </MDBox> */}
                          <MDBox mt={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                multiline
                                rows={3}
                                onChange={handleChange}
                                name="transferNarration"
                                label="Narration"
                                sx={{ minWidth: 120, width: "100%" }}
                              />
                            </FormControl>
                          </MDBox>
                          {totalSpendAmount && transferFee ? (
                            <MDBox mt={3}>
                              <Alert severity="info">
                                <MDBox>
                                  <MDTypography variant="caption" fontWeight="light">
                                    <b>Transfer Fee:</b> {currency}{" "}
                                    {transferFee.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="caption" fontWeight="light">
                                    <b>You Pay:</b> {currency}{" "}
                                    {totalSpendAmount.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                              </Alert>
                            </MDBox>
                          ) : (
                            <> </>
                          )}
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" mb={3}>
                        Payment Information
                      </MDTypography>
                      <MDBox mt={1} mb={4}>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>Choose Option</InputLabel>
                          <Select
                            label="Choose Option"
                            onChange={(e) => setBeneficiarySwitch(e.target.value)}
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                          >
                            <MenuItem value="---">---</MenuItem>
                            <MenuItem value="new">New Transfer</MenuItem>
                            <MenuItem value="saved">Saved Beneficiary</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                      <Divider />
                      {beneficiarySwitch === "saved" ? (
                        <>
                          {" "}
                          <MDBox mt={3} mb={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Select a Beneficiary</InputLabel>
                              <Select
                                name="beneficiary"
                                label="Select a Beneficiary"
                                onChange={(e) => {
                                  setSelectedBeneficiary(e.target.value);
                                }}
                                // onChange={(e) => handleCurrencyChange(e.target.value)}
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                {
                                  // --> Notice below changes
                                  currencyBeneficiaries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    currencyBeneficiaries.map((record) => (
                                      <MenuItem value={record.reference}>{record.alias}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                            <Link to="/beneficiaries/create">
                              <MDTypography
                                p={1}
                                variant="caption"
                                color="info"
                                fontWeight="light"
                                sx={{ display: "flex", justifyContent: "flex-end" }}
                              >
                                Create beneficiary
                              </MDTypography>
                            </Link>
                          </MDBox>
                          {beneficiaryName !== null ? (
                            <MDBox mb={3}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <MDInput
                                  readOnly
                                  disabled
                                  type="text"
                                  name="beneficiary_name"
                                  label="Beneficiary Account Holder"
                                  sx={{ minWidth: 120, width: "100%" }}
                                  value={beneficiaryName}
                                />
                              </FormControl>
                            </MDBox>
                          ) : (
                            <> </>
                          )}
                        </>
                      ) : (
                        <MDBox>
                          {beneficiarySwitch === "new" ? (
                            <>
                              {" "}
                              <MDBox mt={3} mb={4}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <InputLabel>Beneficiary Type</InputLabel>
                                  <Select
                                    name="beneficiary_type"
                                    label="Beneficiary Type"
                                    onChange={(e) => setBeneficiaryType(e.target.value)}
                                    sx={{ padding: "12px", paddingLeft: "3px" }}
                                  >
                                    <MenuItem value="individual">Individual</MenuItem>
                                    <MenuItem value="company">Company</MenuItem>
                                  </Select>
                                </FormControl>
                              </MDBox>
                              {currencyPaymentParameters.map((info) => {
                                if (info.options != null) {
                                  return (
                                    <MDBox mb={3}>
                                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                        <InputLabel>{info.display_name}</InputLabel>
                                        <Select
                                          name={info.param}
                                          label={info.display_name}
                                          onChange={(e) => handleuserPaymentInfoChange(e)}
                                          onBlur={handleUserInfoChange}
                                          sx={{ padding: "12px", paddingLeft: "3px" }}
                                        >
                                          {
                                            // --> Notice below changes
                                            info.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                              info.options.map((opt) => (
                                                <MenuItem value={opt.value}>{opt.name}</MenuItem>
                                              ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </MDBox>
                                  );
                                }
                                return (
                                  <MDBox mb={3}>
                                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                      <MDInput
                                        p={2}
                                        onChange={handleuserPaymentInfoChange}
                                        onBlur={handleUserInfoChange}
                                        // value={userPaymentInfo[info.param] || ""}
                                        errorMessages={[`${info.display_name} is required`]}
                                        validators={["required"]}
                                        name={info.param}
                                        label={info.display_name}
                                      />
                                    </FormControl>
                                  </MDBox>
                                );
                              })}
                              {beneficiaryName !== null ? (
                                <MDBox mb={3}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <MDInput
                                      readOnly
                                      disabled
                                      type="text"
                                      name="beneficiary_name"
                                      label="Beneficiary Account Holder"
                                      sx={{ minWidth: 120, width: "100%" }}
                                      value={beneficiaryName}
                                    />
                                  </FormControl>
                                </MDBox>
                              ) : (
                                <> </>
                              )}
                            </>
                          ) : (
                            <> </>
                          )}
                        </MDBox>
                      )}
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
            <MDBox mt={3}>
              <Card sx={{ marginTop: "0px" }}>
                <MDBox p={3} sx={{ textAlign: "right" }}>
                  <MDButton
                    variant="contained"
                    color="dark"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Transfer Funds
                  </MDButton>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreatePayout;
